/**
 * Admin V3 — Overview module — top-level page
 *
 * Mounted at: /admin-v3/overview (see AdminV3.js)
 *
 * SCOPE FOR PHASE 2.1:
 *   - Read-only: 3 independent GET requests via useAdminQuery
 *       /admin/platform-overview, /stats/dashboard, /demand/stats
 *   - 3 visual rows:
 *       Row 1: 4 KPI cards (Revenue today, Bookings today, Drivers online, Pending requests)
 *       Row 2: "Aperçu des réservations" + "Demande en temps réel"
 *       Row 3: "Statistiques plateforme" (wide)
 *   - No mutations; no fetches beyond the 3 above; no chart (Phase 2.1 decision #2)
 *
 * VISUAL POLICY:
 *   Class strings copied from AdminDashboard.js:1064-1078 Dashboard grid +
 *   visualTokens.js (which itself ports from legacy). No new design tokens.
 */

import React from 'react';
import useAdminQuery from '../../shared/hooks/useAdminQuery';
import OverviewKpiGrid from './OverviewKpiGrid';
import OverviewBookingsCard from './OverviewBookingsCard';
import OverviewDemandCard from './OverviewDemandCard';
import OverviewPlatformCard from './OverviewPlatformCard';
import OverviewCommercialBacklogCard from './OverviewCommercialBacklogCard';
import { DEFAULT_LOCALE } from '../../i18n';

const OverviewPage = () => {
  // Three independent queries — each card slice handles its own loading/error.
  const platform  = useAdminQuery('/admin/platform-overview');
  const dashboard = useAdminQuery('/stats/dashboard');
  const demand    = useAdminQuery('/demand/stats');

  return (
    <div className="space-y-5">
      {/* Row 1: KPI grid */}
      <OverviewKpiGrid
        dashboard={dashboard}
        demand={demand}
        locale={DEFAULT_LOCALE}
      />

      {/* Commercial backlog (F2) — renders only when the work-queue flag is ON */}
      <OverviewCommercialBacklogCard locale={DEFAULT_LOCALE} />

      {/* Row 2: Bookings overview + Demand widget */}
      <div className="grid gap-5 grid-cols-1 xl:grid-cols-[2fr_1fr]">
        <OverviewBookingsCard dashboard={dashboard} locale={DEFAULT_LOCALE} />
        <OverviewDemandCard   demand={demand}       locale={DEFAULT_LOCALE} />
      </div>

      {/* Row 3: Platform-wide statistics */}
      <OverviewPlatformCard
        platform={platform}
        dashboard={dashboard}
        locale={DEFAULT_LOCALE}
      />
    </div>
  );
};

export default OverviewPage;
